var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconDiscord = function SvgIconDiscord(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M18.955 14.574a14.9 14.9 0 0 1-4.571 2.306q-.557-.751-.98-1.585a9.7 9.7 0 0 0 1.544-.74 10 10 0 0 1-.377-.294 10.69 10.69 0 0 1-9.142 0q-.18.148-.372.293.738.436 1.541.736-.423.835-.98 1.588a15 15 0 0 1-4.57-2.306c-.319-3.37.32-6.79 2.67-10.296A14.7 14.7 0 0 1 7.447 3.12q.27.477.49.98a14 14 0 0 1 4.128 0c.129-.31.313-.694.476-.98 1.287.218 2.54.605 3.725 1.15 2.044 3.006 3.06 6.397 2.687 10.303zM13 8.858c-.908 0-1.623.823-1.623 1.825s.732 1.819 1.623 1.819c.892 0 1.613-.82 1.623-1.823s-.715-1.82-1.623-1.82m-6 0c-.908 0-1.623.823-1.623 1.825S6.11 12.502 7 12.502c.892 0 1.616-.82 1.624-1.823S7.907 8.859 7 8.859",
    clipRule: "evenodd"
  })));
};
export default SvgIconDiscord;